import { render, staticRenderFns } from "./personalRequests.vue?vue&type=template&id=0321f519&scoped=true"
import script from "./personalRequests.vue?vue&type=script&lang=js"
export * from "./personalRequests.vue?vue&type=script&lang=js"
import style0 from "./personalRequests.vue?vue&type=style&index=0&id=0321f519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321f519",
  null
  
)

export default component.exports